import React from 'react';
import RegistrationForm from 'components/registration';
import { createStyles } from '../../globalStyles';

const RegistrationPage = (): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={classes.formWrapper}>
      <h1 className={classes.title}>Activate Your Account</h1>
      <RegistrationForm />
    </div>
  );
};

export default RegistrationPage;
